// gkc_hash_code : 01E7J1BV41XHVJMHH8Y4PHXG7H
import React, { useRef } from 'react';
import { useDrag, useDrop } from 'react-dnd';
import { isNumber } from 'lodash/lang';

const DragableBodyRow = ({ index, moveRow, className, style, ...restProps }) => {
  const dragDropRef = useRef(null);
  const [{ isOver, dropClassName }, drop] = useDrop({
    accept: 'DragableBodyRow',
    collect: (monitor) => {
      const { index: dragIndex } = monitor.getItem() || {};
      if (dragIndex === index) {
        return {};
      }
      return {
        isOver: monitor.isOver(),
        dropClassName: dragIndex < index ? ' drop-over-downward' : ' drop-over-upward',
      };
    },
    drop: (item: any) => {
      moveRow(item.index, index);
    },
  });
  const [, drag] = useDrag({
    item: { type: 'DragableBodyRow', index },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });
  drop(drag(dragDropRef));
  if (!isNumber(index)) return null;
  return (
    <tr
      ref={dragDropRef}
      className={`${className}${isOver ? dropClassName : ''}`}
      style={{ cursor: 'move', ...style }}
      {...restProps}
    />
  );
};

export default DragableBodyRow;
